import React from 'react'
import styles from '../Components/ExperienceEachWrapper.module.css'

const ExperienceEachWrapper = props => {
    const { vergeType, item } = props
    return (
        <div className={styles.mainWrapper}>
            <div className={styles.leftBox}>
                <div className={styles.pipeWrapper}>
                    {vergeType !== 'north' ?
                        <div className={styles.pipe}>

                        </div>
                        :
                        <div className={styles.hiddenPipe}>

                        </div>
                    }
                </div>
                <div className={styles.circle}>
                    {item?.start_date?.substring(0, 4)}
                </div>
                {vergeType !== 'south' &&
                    <div className={styles.pipeWrapper}>
                        <div className={styles.pipe}>

                        </div>
                    </div>
                }
            </div>
            <div className={styles.rightBox}>
                <div>{item?.designation}</div>
                <div className={styles.storeName}>
                    {item?.storeName}
                </div>
                <div>
                    {item?.storeAddress}
                </div>
                <div className={styles.workDescription}>
                    {item?.workDescription}
                </div>
            </div>
        </div>
    )
}

export default ExperienceEachWrapper